'use client'

import { useState, useEffect, useRef } from 'react'

import { usePathname } from 'next/navigation'

import cn from 'clsx'

import { SiteSettings as SiteSettingsType } from '../../../../apps/benmax/src/types/sanity.types'

type SiteSettingsProp = {
    siteSettings: SiteSettingsType
}

import { Button, NavLink } from 'shared-components'

import Menu from './Menu'

import s from './Header.module.sass'

export default function Header({
    siteSettings,
    companyLogo,
    site,
}: {
    siteSettings: SiteSettingsProp
    companyLogo: any
    site?: string
}) {
    const headerRef = useRef<HTMLDivElement>(null)
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [hasScrolled, setHasScrolled] = useState(false)
    const [nearBottom, setNearBottom] = useState(false)

    const pathname = usePathname()

    const { siteSettings: siteSettingsData } = siteSettings

    useEffect(() => {
        const handleScroll = () => {
            setHasScrolled(window.scrollY > 50)
        }

        handleScroll()

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [pathname])

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY
            const windowHeight = window.innerHeight
            const documentHeight = document.documentElement.scrollHeight

            setNearBottom(scrollY + windowHeight >= documentHeight - 100)
        }

        handleScroll()

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [pathname])

    return (
        <header
            className={cn(
                s.Header,
                isMenuOpen && s.MenuOpen,
                site === 'benmax' && s.Benmax,
                site === 'bems' && s.Bems,
                site === 'amos-air' && s.AmosAir,
                site === 'hydro-industries' && s.HydroIndustries,
                hasScrolled && s.HasScrolled,
                pathname === '/' && s.Home,
                nearBottom && s.NearBottom,
            )}
            ref={headerRef}
        >
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Inner}>
                    <NavLink href="/" className={s.Logo}>
                        {companyLogo}
                    </NavLink>
                    <Button
                        title={isMenuOpen ? 'Close' : 'Menu'}
                        handleClick={() => setIsMenuOpen(!isMenuOpen)}
                        className={s.MenuButton}
                        inverted={site !== 'amos-air'}
                        transparent={site === 'bems'}
                        noArrow
                        small
                    />
                    <Menu
                        headerMenu={siteSettingsData?.headerMenu}
                        menuCta={siteSettingsData?.menuCta}
                        isOpen={isMenuOpen}
                        site={site}
                        hasScrolled={hasScrolled}
                        headerRef={headerRef}
                    />
                </div>
            </div>
        </header>
    )
}
